import Cookies from 'js-cookie';
import { generateGUID } from './database/firebase-budget-tool';

/**
 * Get voter cookie data for a specific guide
 * If cookie doesn't exist, creates a new voter with unique ID
 * @param {string} guideId - The REBEL experience guide ID
 * @returns {object} Voter data { voterId, lastSubmitted }
 */
export const getVoterCookie = (guideId) => {
  const cookieName = `rebel_voter_${guideId}`;
  const existing = Cookies.get(cookieName);

  if (existing) {
    try {
      return JSON.parse(existing);
    } catch (error) {
      console.error('Error parsing voter cookie:', error);
      // If cookie is corrupted, create new voter
    }
  }

  // Create new voter
  const newVoter = {
    voterId: generateGUID(),
    lastSubmitted: {}
  };

  Cookies.set(cookieName, JSON.stringify(newVoter), { expires: 30 });
  return newVoter;
};

/**
 * Update voter cookie with new rankings
 * @param {string} guideId - The REBEL experience guide ID
 * @param {string} voterId - The unique voter ID
 * @param {object} rankings - The rankings object { experienceId: rank }
 */
export const updateVoterCookie = (guideId, voterId, rankings) => {
  const cookieName = `rebel_voter_${guideId}`;
  const data = {
    voterId,
    lastSubmitted: rankings
  };

  Cookies.set(cookieName, JSON.stringify(data), { expires: 30 });
};
